import { render, staticRenderFns } from "./ChartSummary.vue?vue&type=template&id=0be9a2e0&scoped=true&"
import script from "./ChartSummary.vue?vue&type=script&lang=js&"
export * from "./ChartSummary.vue?vue&type=script&lang=js&"
import style0 from "./ChartSummary.vue?vue&type=style&index=0&id=0be9a2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9a2e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be9a2e0')) {
      api.createRecord('0be9a2e0', component.options)
    } else {
      api.reload('0be9a2e0', component.options)
    }
    module.hot.accept("./ChartSummary.vue?vue&type=template&id=0be9a2e0&scoped=true&", function () {
      api.rerender('0be9a2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leads/ChartSummary.vue"
export default component.exports